module.exports = __webpack_public_path__ + "media/images/story/icon/trash-9813b08ac98e9e76a8a8c2ddaf244580.svg";